import React from 'react';

import { PageFilters } from '@modules/shared/organisms';
import { useStudentPerformanceStatsFiltersQuery } from '@modules/students/hooks';
import { useCurrentLap } from '@modules/lap/hooks';
import { ToolbarFilters } from './toolbar-filters';

import type { StudentPerformanceStatsFilters as Filters } from '@modules/students/hooks';

const initialFilters: Filters = {
    courseId: '',
};

const StudentPerformanceStatsFilters = (): React.ReactElement => {
    const { filters: queryFilters } = useStudentPerformanceStatsFiltersQuery();

    const { currentLap } = useCurrentLap();

    const defaultFilters = React.useMemo(
        () => ({
            ...initialFilters,
            courseId: currentLap.course.id,
        }),
        [currentLap.course.id],
    );

    return (
        <PageFilters queryFilters={queryFilters} initials={defaultFilters}>
            <ToolbarFilters />
        </PageFilters>
    );
};

export { StudentPerformanceStatsFilters };
